<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      :show-save-button="false"
      unit="学习培训"
      id-key="ClassId"
      :data="data"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close="closeFun"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名" prop="TeacherName">
              <el-input
                v-model="data.TeacherName"
                @focus="onTeacherDialog"
                readonly
                placeholder="点击选择"
                v-if="$permission.canAll(path) && !check"
              ></el-input>
              <span v-else>{{data.TeacherName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="活动主题" prop="Theme">
              <el-autocomplete
                v-model="data.Theme"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入活动主题"
                @select="handleSelect"
                style="width:100%"
                v-if="!check"
              ></el-autocomplete>
              <span v-else>{{data.Theme}}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="活动主题" prop="Theme">
              <el-input v-model="data.Theme" placeholder="请输入活动主题" clearable v-if="!check"></el-input>
              <span v-else>{{data.Theme}}</span>
            </el-form-item>
          </el-col> -->
          <el-col :span="isMB?24:12">
            <el-form-item label="类型" prop="GdType">
              <el-select v-model="data.GdType" clearable style="width:100%;" v-if="!check">
                <el-option
                  v-for="item in Theme2List"
                  :value="item.DataName"
                  :label="item.DataName"
                  :key="item.DataName"
                ></el-option>
              </el-select>
              <span v-else>{{data.GdType}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学科/处室" prop="SubjectDp">
              <el-input v-model="data.SubjectDp" placeholder="请填写学科/处室" v-if="!check"></el-input>
              <span v-else>{{data.SubjectDp}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="活动时间" prop="ProjectDate">
              <el-date-picker
                v-model.trim="data.ProjectDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                v-if="!check"
              ></el-date-picker>
              <span v-else>{{$commonJs.toDateString(data.ProjectDate)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="天数" prop="Days">
              <el-input v-model="data.Days" type="number" placeholder="请填写天数" v-if="!check"></el-input>
              <span v-else>{{data.Days}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动内容" prop="Content">
              <el-input type="textarea" v-model="data.Content" placeholder="请输入活动内容" v-if="!check"></el-input>
              <span v-else>{{data.Content}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="活动组织者" prop="Organizer">
              <el-input v-model="data.Organizer" placeholder="请填写活动组织者" v-if="!check"></el-input>
              <span v-else>{{data.Organizer}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="活动地点" prop="Place">
              <el-input v-model="data.Place" placeholder="请填写活动地点" v-if="!check"></el-input>
              <span v-else>{{data.Place}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="活动级别" prop="GdLv">
              <el-select v-model="data.GdLv" clearable style="width:100%;" v-if="!check">
                <el-option
                  v-for="item in ThemeLvList"
                  :value="item.DataName"
                  :label="item.DataName"
                  :key="item.DataName"
                ></el-option>
              </el-select>
              <span v-else>{{data.GdLv}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="考核情况" prop="GdCheck">
              <el-select v-model="data.GdCheck" clearable style="width:100%;" v-if="!check">
                <el-option
                  v-for="item in GradeList"
                  :value="item.DataName"
                  :label="item.DataName"
                  :key="item.DataName"
                ></el-option>
              </el-select>
              <span v-else>{{data.GdCheck}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label=" 证明附件" prop="CertUrl">
              <import-file
                :upload-url="api.UploadFileUrl"
                :subData="subData"
                text="上传附件"
                w="150px"
                :disabled="check"
                :btntype="!check"
                single
                @on-uploaded="uploaded"
                :uploadFiles="uploadedFiles"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="examineDiary" v-if="isOpen">审批日志</el-button>
        <el-button type="primary" @click="diaryEdit" v-if="isOpen">修改日志</el-button>
        <el-button type="success" v-if="!isEdit && !check" @click="()=>{save()}">保存</el-button>
        <el-button
          type="primary"
          v-if="(data.Status==0 || data.Status==2) && !check"
          @click="()=>{Submit()}"
        >提交</el-button>
        <el-button type="primary" @click="examine" v-if="isEdit">通过</el-button>
        <el-button type="danger" @click="cancelExamine" v-if="isEdit">退回</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <teacher-dialog
      ref="teacherDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setTeacher"
    />
    <details-dialog ref="detailsDialog" @close-saved="()=>{$emit('close-saved'),save(),close(1)}"></details-dialog>
    <diary-dialog ref="diaryDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></diary-dialog>
    <examine-dialog ref="examineDialog" @close-saved="()=>{$emit('diary-saved'),close(1)}"></examine-dialog>
  </div>
</template>
<script>
import examineDialog from "@/components/gd/training/list4/examineDialog";
import diaryDialog from "@/components/gd/training/list4/diaryDialog";
import detailsDialog from "@/components/gd/training/list4/detailsDialog";
import teacherDialog from "@/components/fa/teacher/listDialog";
import importFile from "@/components/common/files/importFile";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import router from "@/router";
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

export default {
  props: {
    ThemeLvList: {
      type: Array,
      default: [],
    },
    ThemeList: {
      type: Array,
      default: [],
    },
    Theme2List: {
      type: Array,
      default: [],
    },
    GradeList: {
      type: Array,
      default: [],
    },
    projectList: {
      type: Array,
      default: [],
    },
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
    teacherDialog,
    detailsDialog,
    diaryDialog,
    examineDialog,
  },
  data() {
    return {
      path: router.history.current.path,
      data: {
        TrainId: 0,
        TeacherId: JSON.parse(localStorage.getItem("loginInfo")).TeacherId,
        TeacherName: JSON.parse(localStorage.getItem("loginInfo")).UserName,
        // TrainName: "",
        ProjectDate: "",
        Person: "",
        SubjectDp: "",
        Days: "",
        Theme: "",
        GdType: "",
        GdLv: "",
        GdCheck: "",
        CertUrl: "",
        CertName: "",
        Status: 0,
        Organizer: "",
        TrainNo: "",
        Content: "",
        Place: "",
      },
      uploadedFiles: [],
      files: [],
      subData: {
        dic: "Gd",
      },
      api: require("@/api/gd/train").default,
      Base_api: require("@/api/gd/basedata").default,
      gradeApi: require("@/api/ed/grade").default,
      termApi,
      isMB: this.$store.state.isMB,
      // gradeList: [],
      termList: [],
      isEdit: false,
      isOpen: false,
      check: false,
      rules: {
        TeacherName: [{ required: true, message: "请选择人员" }],
        // TrainName: [{ required: true, message: "请输入项目名称" }],
        TrainNo: [{ required: true, message: "请输入编号" }],
        ProjectDate: [{ required: true, message: "请选择活动时间" }],
        GdType: [{ required: true, message: "请选择类型" }],
        Person: [{ required: true, message: "请选择人员" }],
        SubjectDp: [{ required: true, message: "请选择学科/处室" }],
        Days: [{ required: true, message: "请输入天数" }],
        Theme: [{ required: true, message: "请输入活动主题" }],
        Content: [{ required: true, message: "请输入内容" }],
        GdCheck: [{ required: true, message: "请选择考核情况" }],
        GdLv: [{ required: true, message: "请选择级别" }],
        Organizer: [{ required: true, message: "请填写组织者" }],
        Place: [{ required: true, message: "请填写地点" }],
        CertUrl: [{ required: true, message: "请上传附件" }],
      },
    };
  },
  computed: {},
  methods: {
    closeFun() {
      this.uploadedFiles = [];
    },
    handleSelect(item) {
      console.log(item);
      this.data.Theme = item.value;
    },
    querySearchAsync(queryString, cb) {
      var projectList = this.projectList;
      var results = queryString
        ? projectList.filter(this.createStateFilter(queryString))
        : projectList;
      cb(results);
    },
    onBeforeSave() {},
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    examineDiary() {
      this.$refs.examineDialog.openEdit({
        RecordId: this.data.TrainId,
        MenuName: "学习培训",
        Gd: true,
      });
    },
    diaryEdit() {
      this.$refs.diaryDialog.openEdit({
        RecordId: this.data.TrainId,
        MenuName: "学习培训",
      });
    },
    Submit() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) {
          return;
        }
        this.onBeforeSave();
        this.$refs.dialog.isLoading = true;
        this.api.submit(this.data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.readonly = true;
            this.close(1);
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.save();
        this.api.examine(this.data.TrainId).then((res) => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.readonly = true;
            this.close(1);
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    cancelExamine() {
      sessionStorage.setItem("cancel", "3");
      this.$refs.detailsDialog.openEditById(this.data.TrainId);
    },
    // cancelExamine() {
    //   this.$confirm("确认退回吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //   .then(() => {
    //     this.api.cancelExamine(this.data.TrainId).then(res => {
    //       if(res.Code ==0) {
    //         this.$message.success(res.Msg)
    //         this.readonly = false
    //         this.close()
    //         this.$emit("close-saved")
    //       } else {
    //         this.$message.error(res.Msg)
    //       }
    //     })
    //   })
    // },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId;
      this.data.TeacherName = t.TeacherName;
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    uploaded(res, fileList) {
      console.log("uploaded", res, fileList);
      this.fileList = fileList;
      this.data.CertUrl = res.Data.VirtualPath;
      this.data.CertName = res.Data.FileName + "." + res.Data.Extension;
    },
    onCreateOpened() {
      this.isEdit = false;
      this.isOpen = false;
      this.check = false;
      this.api.getpreviewno().then((res) => {
        if (res.Code == 0) {
          this.data.TrainNo = res.Data;
        }
      });
      // this.data.TermId = loginInfo.TermId;
      // this.getOption()
    },
    onEditOpened(row) {
      this.isOpen = true;
      if (sessionStorage.getItem("check") === "1") {
        this.isEdit = true;
        this.check = false;
        sessionStorage.removeItem("check");
      } else if (sessionStorage.getItem("check") === "2") {
        this.isEdit = false;
        this.check = true;
        sessionStorage.removeItem("check");
      } else {
        this.check = false;
        this.isEdit = false;
      }
      if (this.data.CertUrl) {
        this.uploadedFiles = [
          {
            name: this.data.CertName,
            url:
              location.protocol +
              "//" +
              location.host +
              "/api" +
              this.data.CertUrl,
          },
        ];
      }
    },
  },
};
</script>
<style lang="scss">
</style>